function getCookies() {
    const cookies = []
    const cookiesList = [
        /^_ga$/, // Main Google Analytics Cookie
        /^_gid$/,
        /^_gcl_au$/,
        /^_ga_[A-Z,0-9]/, // Google Analytics 4 Session Cookie
        /^FPLC$/, // First Party Linker Cookie > sGTM
    ]
    let _FPLC = undefined
    ;('; ' + document.cookie).split('; ').forEach(function (ck) {
        let name = ck.split('=')[0]
        let value = ck.split('=')[1]
        cookiesList.forEach((regex) => {
            if (regex.test(name)) {
                if (name === 'FPLC') {
                    _FPLC = ['_fplc', btoa(value).replace(/=/g, '.')].join('*')
                } else {
                    if (name.match(/^_ga/)) {
                        const match = value.match(/G[A-Z]1\.[0-9]\.(.+)/)
                        if (match && match[1]) {
                            value = match[1]
                        }
                    }

                    cookies.push([name, btoa(value).replace(/=/g, '.')].join('*'))
                }
            }
        })
    })
    if (_FPLC) {
        cookies.push(_FPLC)
    }

    return cookies
}

function getFingerPrint(cookies = '') {
    const fingerPrintString = [
        window.navigator.userAgent,
        new Date().getTimezoneOffset(),
        window.navigator.userLanguage || window.navigator.language,
        Math.floor(new Date().getTime() / 60 / 1e3) - 0,
        cookies ? cookies.join('*') : '',
    ].join('*')
    let c
    const crcTable = []
    for (var n = 0; n < 256; n++) {
        c = n
        for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1
        }
        crcTable[n] = c
    }
    let crc = 0 ^ -1
    for (let i = 0; i < fingerPrintString.length; i++) {
        crc = (crc >>> 8) ^ crcTable[(crc ^ fingerPrintString.charCodeAt(i)) & 0xff]
    }
    crc = ((crc ^ -1) >>> 0).toString(36)
    return crc
}

const google_tag_linker = function (action = 'get', settings = {}) {
    const cookies = getCookies()
    if (action === 'get') {
        return ['1', getFingerPrint(cookies), cookies.join('*')].join('*')
    }
}

google_tag_linker.prototype = {}
google_tag_linker.answer = 42
